"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownMenu = exports.DropdownItem = void 0;

var _react = _interopRequireWildcard(require("react"));

var _atoms = require("../../atoms");

var _reactMenu = require("@szhsin/react-menu");

var _reactDom = _interopRequireWildcard(require("react-dom"));

var _ = require("../..");

require("./DropdownMenu.css");

require("@szhsin/react-menu/dist/index.css");

var _pubsubJs = _interopRequireDefault(require("pubsub-js"));

var _Util = require("../../Util");

var _helpers = require("../../util/helpers");

var _excluded = ["children", "options", "onChange", "button", "onClick", "buttonHeight", "buttonWidth", "className", "classNameMenu", "menuDirection", "menuPosition", "menuAlign", "menuPortal", "background", "disabled", "offsetAxisX", "offsetAxisY", "shadeClick", "transparentShadeClick", "outsideClick", "onClose", "title", "open", "explicitAnchorRef", "useMenuItems"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DROPDOWN_IS_OPENED = "DROPDOWN_IS_OPENED";

var DropdownMenu = function DropdownMenu(_ref) {
  var children = _ref.children,
      options = _ref.options,
      onChange = _ref.onChange,
      button = _ref.button,
      onClick = _ref.onClick,
      buttonHeight = _ref.buttonHeight,
      buttonWidth = _ref.buttonWidth,
      className = _ref.className,
      classNameMenu = _ref.classNameMenu,
      menuDirection = _ref.menuDirection,
      menuPosition = _ref.menuPosition,
      menuAlign = _ref.menuAlign,
      menuPortal = _ref.menuPortal,
      background = _ref.background,
      disabled = _ref.disabled,
      offsetAxisX = _ref.offsetAxisX,
      offsetAxisY = _ref.offsetAxisY,
      shadeClick = _ref.shadeClick,
      transparentShadeClick = _ref.transparentShadeClick,
      outsideClick = _ref.outsideClick,
      onClose = _ref.onClose,
      title = _ref.title,
      open = _ref.open,
      explicitAnchorRef = _ref.explicitAnchorRef,
      useMenuItems = _ref.useMenuItems,
      props = _objectWithoutProperties(_ref, _excluded);

  var defaultOpen = open !== null ? open : false;
  var menuButtonRef = /*#__PURE__*/(0, _react.createRef)();

  var _useState = (0, _react.useState)(defaultOpen),
      _useState2 = _slicedToArray(_useState, 2),
      isDropdownOpen = _useState2[0],
      setIsDropdownOpen = _useState2[1];

  var isMobileScreenSize = (0, _helpers.isSmallMobileScreen)();
  var btnHeight = buttonHeight ? buttonHeight : "100%";
  var btnWidth = buttonWidth ? buttonWidth : "100%";
  var backgroundColor = background ? background : _atoms.Color.White1;
  var position = isMobileScreenSize ? "auto" : menuPosition ? menuPosition : "anchor";
  var direction = menuDirection ? menuDirection : "right";
  var align = menuAlign ? menuAlign : "center";
  var height = window.innerHeight;
  var offsetX = isMobileScreenSize ? 0 : offsetAxisX ? offsetAxisX : 0;
  var offsetY = isMobileScreenSize ? height : offsetAxisY ? offsetAxisY : 0;
  (0, _react.useEffect)(function () {
    document.body.style.overflow = isDropdownOpen ? "hidden" : "unset";

    if (isDropdownOpen) {
      (0, _Util.addClassName)(document.body, 'dropdown-open');
    } else {
      (0, _Util.removeClassName)(document.body, 'dropdown-open');
    }
  }, [isDropdownOpen]);
  (0, _react.useEffect)(function () {
    if (explicitAnchorRef && explicitAnchorRef.current) {
      setIsDropdownOpen(true);
    }
  }, [explicitAnchorRef]);
  var openClass = isDropdownOpen ? "open" : "closed";
  var buttonStyles = {
    height: btnHeight,
    width: btnWidth,
    background: background ? "var(--".concat(backgroundColor, ")") : "none"
  };
  (0, _react.useEffect)(function () {
    if (open !== null) {
      console.log('dropdown', open);
      setIsDropdownOpen(open);
    }
  }, [open]);
  (0, _react.useEffect)(function () {
    _pubsubJs.default.publish(DROPDOWN_IS_OPENED, isDropdownOpen);
  }, [isDropdownOpen]);
  (0, _react.useEffect)(function () {
    if (!isDropdownOpen && typeof onClose === 'function') {
      onClose();
    }
  }, [isDropdownOpen]);

  var onSelected = function onSelected(e, value) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    open === null && setIsDropdownOpen(false);
    if (onChange) onChange(e, value);
  };

  var onButtonClick = function onButtonClick(e) {
    if (e) {
      e.preventDefault();
    }

    open === null && setIsDropdownOpen(!isDropdownOpen);
    if (onClick) onClick();
  };

  var onShadeClick = function onShadeClick(e) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    console.log('dropdownmenu shade click');
    open === null && setIsDropdownOpen(false);
    if (shadeClick && typeof shadeClick === 'function') shadeClick(false);
  };

  var onTransparentShadeClick = function onTransparentShadeClick(e) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    console.log('dropdownmenu transparent shade click');
    open === null && setIsDropdownOpen(false);
    if (transparentShadeClick && typeof transparentShadeClick === 'function') transparentShadeClick();
  }; // Get the modal root container


  var modalRoot = menuPortal ? document.querySelector(menuPortal) : document.body; // remove the dropdown props from the dom

  var attr = _objectSpread({}, props);

  delete attr['shouldCloseOnSelection'];

  var renderPortal = function renderPortal() {
    var usableAnchorRef = explicitAnchorRef ? explicitAnchorRef : menuButtonRef;
    return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_atoms.Element, {
      className: className,
      trkContext: "".concat(title, " Dropdown")
    }, isDropdownOpen && !isMobileScreenSize && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
      onClick: function onClick(e) {
        return onTransparentShadeClick(e);
      },
      className: "transparent-shade"
    }), !isMobileScreenSize && /*#__PURE__*/_react.default.createElement(_reactMenu.ControlledMenu, _extends({}, attr, {
      anchorRef: usableAnchorRef,
      state: isDropdownOpen ? 'open' : 'closed',
      className: "".concat(isDropdownOpen && !isMobileScreenSize ? "".concat(classNameMenu, " ").concat(className, " DropdownMenuContent szh-menu--open") : "".concat(classNameMenu, " ").concat(className)),
      position: position,
      unmountOnClose: true,
      align: align,
      direction: direction,
      offsetX: offsetX,
      offsetY: offsetY,
      onChange: function onChange() {
        !isMobileScreenSize && open === null && setIsDropdownOpen(!isDropdownOpen);
      }
    }), options && !isMobileScreenSize && isDropdownOpen && options.map(function (option) {
      if (useMenuItems) {
        return /*#__PURE__*/_react.default.createElement(_reactMenu.MenuItem, {
          key: "key-".concat(option.value)
        }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
          trkAction: "".concat(option.title, " Pressed"),
          className: "DropdownItem",
          onClick: function onClick(e) {
            return onSelected(e, option.value);
          }
        }, option.iconType && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
          size: 16,
          type: option.iconType
        }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
          type: _atoms.Label.Type.Body,
          content: option.title,
          marginLeft: "2",
          marginRight: "2"
        })));
      } else {
        return /*#__PURE__*/_react.default.createElement(_atoms.Row, {
          key: "key-".concat(option.value),
          trkAction: "".concat(option.title, " Pressed"),
          className: "DropdownItem",
          onClick: function onClick(e) {
            return onSelected(e, option.value);
          }
        }, option.iconType && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
          size: 16,
          type: option.iconType
        }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
          type: _atoms.Label.Type.Body,
          content: option.title,
          marginLeft: "2",
          marginRight: "2"
        }));
      }
    }), children && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, useMenuItems && /*#__PURE__*/_react.default.createElement(_reactMenu.MenuItem, {
      key: "avatardropdown-menuitem"
    }, children), !useMenuItems && children)), isMobileScreenSize && isDropdownOpen && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
      className: "DropdownMenuShadeMobile ".concat(openClass),
      onClick: function onClick(e) {
        return onShadeClick(e);
      }
    }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
      className: "DropdownMenuContentMobile ".concat(openClass)
    }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
      className: "DropdownMenuOptionsMobile"
    }, options && options.map(function (opt) {
      return /*#__PURE__*/_react.default.createElement(DropdownItem, {
        key: "key-".concat(opt.value),
        option: opt,
        title: opt.title,
        value: opt.value,
        onClick: function onClick(e) {
          return onSelected(e, opt.value);
        }
      });
    }), children)))), modalRoot);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !explicitAnchorRef && /*#__PURE__*/_react.default.createElement(_reactMenu.MenuButton, {
    ref: menuButtonRef,
    disabled: !!disabled,
    onClick: function onClick(e) {
      return onButtonClick(e);
    },
    className: "DropdownMenuTarget ".concat(classNameMenu ? classNameMenu : ""),
    styles: buttonStyles
  }, button, isDropdownOpen && isMobileScreenSize && /*#__PURE__*/_react.default.createElement(_.Shade, {
    onClick: function onClick(e) {
      return onShadeClick(e);
    },
    className: "dropdown-shade"
  })), renderPortal());
};

exports.DropdownMenu = DropdownMenu;
DropdownMenu.defaultProps = {
  open: null,
  useMenuItems: true
};

var DropdownItem = function DropdownItem(_ref2) {
  var selected = _ref2.selected,
      onClick = _ref2.onClick,
      option = _ref2.option;
  return /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    trkAction: "".concat(option.title, " Pressed"),
    tag: "button",
    className: "DropdownItem ".concat(selected ? "selected" : ""),
    onClick: onClick
  }, option.iconType && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: 16,
    type: option.iconType
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    content: option.title,
    marginLeft: "2",
    marginRight: "2"
  }));
};

exports.DropdownItem = DropdownItem;